import React, { useState, useCallback } from "react";
import { GridActionsCellItem, useGridApiRef } from "@mui/x-data-grid-pro";
import { requiredCell, validateEmail } from "../../js/utils/inputValidations";
import * as r from "../../js/constants/routes";
import GroupsIcon from '@mui/icons-material/Groups';
import DataGridComponent, {
    rowDisableDelete,
    conditionalEditDisabling,
} from "../Widgets/DataGridComponent";
import { useSelector } from "react-redux";
import { ButtonToolbar } from "../Widgets/Custom Inputs/Buttons";
import { t } from "react-i18nify";
import { BasicTooltip } from "../Widgets/StyledComponents";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { VSelectURL } from "../Widgets/Custom Inputs/Select";
import { Grid } from "@mui/system";
import { FormProvider, useForm } from "react-hook-form";
import EditionPanelGlobal from "../Views/Edition panels/EditionPanelGlobal";
import { Dialog, DialogContent } from "@mui/material";
import { HiddenField, VDateOnlyPicker } from "../Widgets/Custom Inputs/CustomInputs";
import { dateOnlyToString } from "../../js/utils/genericMethods";
import { deleteModel } from "../../js/utils/backend";

/** CommentComponent */
const SharesGrid = ({
    label = t("common.SharesList"),
    baseURL = `${r.sharedDocument.route}`,
    specificToolbar = null,
    checkboxSelection,
    selectionModel,
    onSelectionModelChange,
    hideActionColumn = false,
    isInPannel = false,
    backAction = null,
    ...props
}) => {
    const apiRef = useGridApiRef();
    const cellFocusField = "IGG";
    const userID = useSelector(state => state.auth.UserID);
    const token = useSelector(state => state.auth.Token);
    const { documentID } = useParams();
    const [forceGridRefresh, setForceGridRefresh] = useState(false);
    const [openEditSharesList, setOpenEditSharesList] = useState(false);
    const { CompanyManager, HoldingManager } = useSelector(state => state.auth);
    // const  [visitedRow]  = useState();

    const methods = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const onSubmit = useCallback(() => {
        setForceGridRefresh(fgr => !fgr);
    }, [setForceGridRefresh]);

    const gridSpecificColumns = [
        {
            field: "IGG",
            headerName: "IGG",
            flex: 1,
            editable: true,
            preProcessEditCellProps: params => {
                const hasError = requiredCell(params, apiRef, "IGG", "IGG");
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "Firstname",
            headerName: t("field.Firstname"),
            flex: 1,
            editable: true,
        },
        {
            field: "Lastname",
            headerName: t("field.Lastname"),
            flex: 1,
            editable: true,
        },
        {
            field: "Email",
            headerName: "EMail",
            flex: 1,
            editable: true,
            preProcessEditCellProps: params => {
                const hasError = validateEmail(
                    params,
                    apiRef,
                    "EMail",
                    "EMail"
                );
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "ExternalProvider",
            headerName: t("field.ExternalProvider"),
            flex: 1,
            editable: true,
        },
        {
            field: "CategoryName",
            headerName: t("field.Category"),
            flex: 1,
            editable: false
        },
        {
            field: "ExpirationDate",
            headerName: t("field.ExpirationDate"),
            editable: true,
            valueFormatter: params =>
                dateOnlyToString(params.value, "DateTime"),
        },
    ];


    const specificActionsColumns = (params, _editing, isLocalLoading) => [
        // MEMO : duplicated code with InternalUserGrid, remember to refactor the onClick and uniformize somehow with better transition handling
        <>
            {(CompanyManager || HoldingManager) &&
                !conditionalEditDisabling(params.row) &&
                !rowDisableDelete(params.row, userID, "ID") &&
                apiRef.current.getRowMode(params.id) !== "edit" && (
                    <GridActionsCellItem
                        icon={
                            <BasicTooltip title={t("common.Remove")}>
                                <HighlightOffIcon />
                            </BasicTooltip>
                        }
                        label={t("common.Remove")}
                        className="textPrimary"
                        onClick={async () => {
                            await deleteModel(params.row.ID, token, "shareddocument").then(response => {
                                setForceGridRefresh(fgr => !fgr);
                            });
                        }}
                        color="inherit"
                        disabled={isLocalLoading}
                    />
                )}
        </>
    ];

    return (
        <>
            <Dialog open={Boolean(openEditSharesList)} sx={{ w: 1 }} fullWidth>
                <DialogContent>
                    <FormProvider {...methods}>
                        <EditionPanelGlobal
                            route={"shareddocument"}
                            onSubmit={onSubmit}
                            backAction={() => setOpenEditSharesList(false)}
                        >
                            <Grid item xs={12}>
                                <HiddenField
                                    fieldName={"DocumentID"}
                                    defaultValue={documentID}
                                />
                                <VSelectURL
                                    sx={{ mb:2, mt:4 }}
                                    label={t("grid.title.ExternalUsers")}
                                    URL="User/GetExternalUsers"
                                    // URL={r.oTUser}
                                    // paramURL={r.filter.genericFilter(
                                    //     "External",
                                    //     true
                                    // )}
                                    fieldName={"ExternalUserID"}
                                    validation={{
                                        required: {
                                            value: true,
                                            message: t(
                                                "input.validation.required"
                                            ),
                                        },
                                    }}
                                />
                                {/* <Grid item xs={12}>
                                    <VTextField
                                        sx={{ mb:2 }}
                                        label={t("field.Category")}
                                        fieldName={"Category"}
                                        validation={{
                                            required: {
                                                value: true,
                                                message: t("input.validation.required"),
                                            }
                                        }}
                                    />
                                </Grid> */}
                                <Grid item xs={12}>
                                    <VDateOnlyPicker
                                        sx={{ mb:3 }}
                                        label={t("field.ExpirationDate")}
                                        fieldName={"ExpirationDate"}
                                        removeTodayAsDefault
                                        validation={{
                                            required: {
                                                value: true,
                                                message: t("input.validation.required"),
                                            }
                                        }}
                                        isMinDateValidation={true}
                                    />
                                </Grid>
                            </Grid>
                        </EditionPanelGlobal>
                    </FormProvider>
                </DialogContent>
            </Dialog>
            <DataGridComponent
                apiRef={apiRef}
                selectionModel={selectionModel}
                onSelectionModelChange={onSelectionModelChange}
                baseURL={`${baseURL}/GetUsersByDocumentID/${documentID}`}
                cellFocusField={cellFocusField}
                label={label}
                gridSpecificColumns={gridSpecificColumns}
                initialState={{
                    sorting: {
                        sortModel: [{ field: "Firstname", sort: "asc" }],
                    },
                }}
                isAddDisabled={true}
                isEditDisabled={true}
                withBackButton={true}
                toolbar={
                    specificToolbar ?? {
                        newAction: (
                            <ButtonToolbar
                                titleTooltip={t("common.Add")}
                                title={t("common.Add")}
                                startIcon={<GroupsIcon />}
                                onClick={() => {
                                    setOpenEditSharesList(true);
                                }}
                            />
                        )
                    }
                }
                forceGridRefresh={forceGridRefresh}
                isDeleteDisabled={true}
                specificActionsColumns={specificActionsColumns}
                // visitedRow={visitedRow}
                checkboxSelection={checkboxSelection}
                hideActionColumn={hideActionColumn}
                {...props}
            />
        </>
    );
};

export default SharesGrid;
